
import './App.css';
import NavBar from './components/NavBar';

function App() {
  return (
   <NavBar/>
  );
}

export default App;
